import DarkModeIcon from "@components/svg/DarkModeIcon";
import LightModeIcon from "@components/svg/LightModeIcon";
import React, { useState } from "react";

const ThemeChanger = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "light"
  );

  const handleChange = () => {
    if (theme === "light") {
      document.body.classList.add("dark-mode");
      setTheme("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark-mode");
      setTheme("light");
      localStorage.setItem("theme", "light");
    }
  };

  // React.useEffect(() => {
  //   const getTheme = localStorage.getItem("theme");
  //   if (getTheme === "dark") {
  //     document.body.classList.add("dark-mode");
  //   }
  // });

  return (
    <div className="dark-switch">
      <span>{theme === "dark" ? <LightModeIcon /> : <DarkModeIcon />}</span>
      <button className="dark-switch-btn" onClick={handleChange}>
        {theme === "dark" ? "Light Mode" : "Dark Mode"}
      </button>
    </div>
  );
};

export default ThemeChanger;
